import { atom, selector } from "recoil";
import { createDataRequest, updateDataRequest, getBagStatusListRequest, getForwardTypeListRequest,
	getArrivalFlightListRequest, 
	getDepartureFlightListRequest, 
} from "../../../api/controller/BagController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";
import moment from "moment";

export const bagListState = atom({
    key: 'bagListState',
    default: [],
})
export const bagBagStatusState = atom({
	key: 'bagBagStatusState',
	default:{
		data:[],
		ovf:false,
	}
})
export const bagForwardTypeState = atom({
	key: 'bagForwardTypeState',
	default:{
		data:[],
		ovf:false,
	}
})
export const bagArrivalFlightState = atom({
	key: 'bagArrivalFlightState',
	default:{
		data:[],
		ovf:false,
	}
})
export const bagDepartureFlightState = atom({
	key: 'bagDepartureFlightState',
	default:{
		data:[],
		ovf:false,
	}
})
export const bagDamageBagClaimState = atom({
	key: 'bagDamageBagClaimState',
	default:{
		data:[],
		ovf:false,
	}
})

export const bagTypeModState = atom({
    key: 'bagTypeModState',
    default: 'AHL'
})

export const modalConfigDefault = { size: "lg", wizard: false }

export const filtersDefault = [
    {
        label: 'Type',
        size: 4,
        offset: 2,
        required: true,
        type: 'select', // date, dateRange & select only
        value: { label: "AHL", value: 'AHL' }, // String date "yyyy-mm-dd" for date | Array of 2 dates for dateRange | Object as shown for Select { label: "Label", value: 0 }
        list: [
            { label: 'AHL', value: 'AHL' },
            { label: 'DPR', value: 'DPR' },
            { label: 'OHD', value: 'OHD' },
            { label: 'UNCLAIMED', value: 'UNCLAIMED' },
            { label: 'CLAIMS', value: 'CLAIMS' },
        ]
    },
    {
        label: 'Period',
        size: 6,
        required: true,
        type: 'dateRange', // date, dateRange & select only
        value: [moment().subtract(21,'days').format("YYYY-MM-DD"),moment().format("YYYY-MM-DD")], // String date "yyyy-mm-dd" for date | Array of 2 dates for dateRange | Object as shown for Select { label: "Label", value: 0 }
        list: [], // only for select -> Array should have Objects as shown { label: "Label", value: 0 }
    },
]

export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest } ],
    view: [ { name: 'Default View' } ],
}

export const bagDataStructureState = selector({
    key: 'bagDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'Reference',
                field: 'case_file.primary_reference',
                type: 'text',
                order: { form: 0.1, table: 0.1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'readonly'  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
            { 
                label: 'Type',
                field: 'case_file.type',
                type: 'text',
                order: { form: 0.2, table: 0.2 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'readonly'  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
            { 
                label: 'Flight Date',
                field: 'case_file.flight_date',
                type: 'datepicker',
                table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                order: { table: 0.3 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
            { 
                label: 'Flight',
                field: 'case_file.flight',
                type: 'text',
                order: { table: 0.4 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
            { 
                label: 'Address',
                field: 'case_file.address.name',
                type: 'text',
                order: { table: 0.5 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
            { 
                label: 'Tag Number',
                type: 'text',
                order: { form: 1, table: 1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
            { 
                label: 'Color Type',
                field: 'color_type',
                type: 'text',
                order: { form: 1.05}, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }, creatable: true  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Bag Status',
                type: 'select',
                order: { form: 2, table: 2 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], 
                update: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden'  }], 
                view: ['same_as:create.0'], 
				list: get(bagBagStatusState),
				getRequest: getBagStatusListRequest,
            },
			{ 
                label: 'Arriving Flight',
                name: 'LocationHistory',
                field: 'location_history',
                type: 'text',
                order: { form: 3 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }, validations: 'hidden_if:BagStatus,TRACING|hidden_if:Type,DPR,OHD,UNCLAIMED'  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Receive Date',
                type: 'datepicker',
                order: { form: 4, }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:BagStatus,TRACING,LOCATED' , dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
                child: {
                    name: "ReceivedFlight",
                    subFields: { label: "name", value: "name" }, 
                    fn: getArrivalFlightListRequest
                }
            },
			{ 
                label: 'Received Flight',
                type: 'select',
                rootValue: true,
                order: { form: 5, }, 
                create: [{ enabled: true, creatable: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:BagStatus,TRACING,LOCATED|disabled_if:ReceiveDate,null' }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
                list: get(bagDepartureFlightState),
            },
			{
				label: 'Received Weight (kg)',
				name: 'ReceivedWeight',
				field: 'received_weight',
				type: 'number',
				order: { form: 5.05 },
				create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:BagStatus,TRACING,LOCATED', default: '' }],
				update: ['same_as:create.0'],
				view: ['same_as:create.0'],
			},
			{ 
                label: 'DPR Receive Date',
                field: 'damage_bag_receive_date',
                name: 'DamageBagReceiveDate',
                type: 'datepicker',
                order: { form: 5.1, table: get(bagTypeModState) === "DPR" ? 3 : 0 }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:Type,!DPR', dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'DPR Claim',
                field: 'dpr_claim',
                type: 'text',
                order: { form: 5.2, table: get(bagTypeModState) === "DPR" ? 3.1 : 0 }, 
                create: [{ enabled: false }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Forward Date',
                type: 'datepicker',
                order: { form: 6, }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:BagStatus,!FORWARDED' , dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
                child: {
                    name: "ForwardFlight",
                    subFields: { label: "name", value: "name" }, 
                    fn: getDepartureFlightListRequest
                }
            },
			{ 
                label: 'Forward Flight',
                type: 'select',
                rootValue: true,
                order: { form: 7, }, 
                create: [{ enabled: true, creatable: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:BagStatus,!FORWARDED|disabled_if:ForwardDate,null' }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
                list: get(bagArrivalFlightState)
            },
			{ 
                label: 'Forward Type',
                type: 'select',
                order: { form: 8 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:BagStatus,!FORWARDED' }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				list: get(bagForwardTypeState),
				getRequest: getForwardTypeListRequest,
            },
			{ 
                label: 'Rush Tag Number',
                type: 'text',
                order: { form: 9 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:BagStatus,!FORWARDED' }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Deliver Date',
                type: 'datepicker',
                order: { form: 10, }, 
                table: { dateFormat: 'HH:mm | MMM Do', postDateFormat:'YYYY-MM-DD HH:mm' },
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:BagStatus,!DELIVERED', dateFormat: 'YYYY-MM-DD HH:mm', options: { altInput: true, enableTime: true, altFormat: 'H:i | F j, Y', dateFormat: 'Y-m-d H:i' } }], 
                update: [{ enabled: false }], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Delivery Name',
                type: 'text',
                order: { form: 11 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:BagStatus,!DELIVERED' }], 
                update: [{ enabled: false }], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Delivery Contact',
                type: 'text',
                order: { form: 12 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:BagStatus,!DELIVERED' }], 
                update: [{ enabled: false }], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Delivery Identity',
                type: 'text',
                order: { form: 13 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:BagStatus,!DELIVERED' }], 
                update: [{ enabled: false }], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Delivery Condition',
                type: 'text',
                order: { form: 13.1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:BagStatus,!DELIVERED' }], 
                update: [{ enabled: false }], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Delivery Signature',
                type: 'signature',
                order: { form: 14 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }, validations: 'hidden_if:BagStatus,!DELIVERED' }], 
                update: [{ enabled: false }], view: ['same_as:create.0'], 
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
